import styled from 'styled-components';

export const FullWidthWrapper = styled.div`
    width: 100%;
    margin-right: 2rem;
`;

export const SettingsHeading = styled.div`
    font-weight: 500;
    font-size: 3.5rem;
    line-height: 1.26;
    max-width: 35rem;
`;

/**
 * Creates a container for the Search Bar and Create New Button
 * Typically used in Table Page layouts
 * @param lessTopPadding Use this if the container is being used on a page with tertiary tabs (e.g. Container Management).
 * Otherwise, if there are secondary tabs, do not use it (e.g. Notification Subscriptions).
 */
export const SearchCreateButtonContainer = styled.div<{
    $lessTopPadding?: boolean;
    justify?: 'start' | 'center' | 'end' | 'space-between';
}>`
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    flex-direction: row;
    justify-content: ${({ justify }) => justify ?? 'space-between'};
    ${({ $lessTopPadding }) =>
        $lessTopPadding
            ? `padding-top: 0.5rem;
               padding-bottom: 1.5rem;`
            : `padding: 1.5rem 0;`}
`;
